module.exports = __webpack_public_path__ + "static/img/r-4-3-icon.037d304.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-4/r-4-3-icon.png
// module id = Fikr
// module chunks = 0